import { JSX } from 'react';

interface FeaturesProps {
  features: Array<string | JSX.Element>;
}

export const InsuranceFeatures = ({ features }: FeaturesProps) => {
  return (
    <div className="flex flex-col">
      {features.map((feature, index) => (
        <div key={index} className="body-14-light inline-flex items-center">
          <span>{feature}</span>
        </div>
      ))}
    </div>
  );
};
